module.exports = __webpack_public_path__ + "frontend/images/logos/small/small-green@2.png?b2e217fd7e550b798f0730ae7fa546a2";